import { type ReactNode } from "react";
import NextLink from "next/link";
import { Link, Text } from "@cruk/cruk-react-components";

import { formatMoneyWithCommas } from "@fwa/src/utils/formatUtils";
import { memberTeamIconUrlForTheme } from "@fwa/src/utils/memberUtils";
import { useBrandContext } from "@fwa/src/contexts/BrandContext";

import sharedStyles from "@fwa/src/components/styles.module.css";
import styles from "@fwa/src/components/MemberTeam/styles.module.css";

import { type SuperTeamPageType } from "@fwa/src/types";

export function MemberSuperTeam({
  superTeamPage,
  children,
}: {
  superTeamPage: SuperTeamPageType;
  children: ReactNode;
}) {
  const { title, donationsTotalAmount } = superTeamPage;
  const [brandName] = useBrandContext();
  const raisedAmount = donationsTotalAmount
    ? formatMoneyWithCommas(donationsTotalAmount)
    : "0.00";
  const iconUrl = memberTeamIconUrlForTheme(brandName);

  return (
    <div className={styles["shadow-wrapper"]}>
      <NextLink
        href={`/unite${superTeamPage.url.slice(
          superTeamPage.url.lastIndexOf("/"),
        )}`}
        aria-label={title}
        title={title}
        data-cta-type="link-super-team"
      >
        <div className={styles["member-link"]}>
          <div
            className={sharedStyles["row"]}
            style={{ gap: "var(--spacing-xs, 8px)" }}
          >
            <div className={styles["profile-image-wrapper"]}>
              <img src={iconUrl} alt="" />
            </div>

            <div
              className={[styles["text-wrapper"], "spacing-props"].join(" ")}
              data-margin-left="xs"
            >
              <Text
                className={[
                  sharedStyles["single-line-ellipsis"],
                  "component-text",
                ].join(" ")}
                marginBottom="none"
              >
                <Link as="span">{`${title}`}</Link>
              </Text>
              <Text
                className={[
                  sharedStyles["single-line-ellipsis"],
                  "component-text",
                ].join(" ")}
                marginBottom="none"
              >
                {`£${raisedAmount} raised`}
              </Text>
            </div>
          </div>
        </div>
      </NextLink>
      {children}
    </div>
  );
}

export default MemberSuperTeam;
